import AboutUs from "./aboutUs/aboutUs";
import HeroSection from "./heroSection/body";
import Courses from "./courses/courses";
import Header from "./header/header";
import Schools from "./schools/schools";
import ChooseUs from "./chooseUs/chooseUs";
import Features from "./Feature-section/Features";
import Newsletter from "./newsletter/newsletter";
import Footer from "./Footer/Footer";

const Homepage = () => {
    return ( 
        <>
        <Header />
        <HeroSection />
        {/* <Schools />
        <AboutUs/>
        <Courses />
        <ChooseUs />
        <Features/>
        <Newsletter/>
        <Footer/> */}
        </>
     );
}
 
export default Homepage;